import { useState } from 'react';
import FilterSetMenu from './FilterSetMenu';
import useEventsTracker from '../tracking/useEventsTracker';
import { LBButton, LBChevronDownIcon } from '@linearb/buzz';

export const FilterSetButtons = ({ Context }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const eventsTracker = useEventsTracker({ Context });

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    eventsTracker.onOpenFilterSetMenu();
  };

  return (
    <div>
      <LBButton
        variant='outline'
        onClick={handleClick}
        data-cy='filter-set-bar-apply-filters-down-arrow-btn'
      >
        <LBChevronDownIcon />
        More
      </LBButton>
      <FilterSetMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        Context={Context}
      />
    </div>
  );
};
